module.exports = __webpack_public_path__ + "static/img/s-vivo-5.14a027b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s-vivo-5.png
// module id = afHE
// module chunks = 0